export const ONBOARDING_NODE_ID_KEYS = {
	SOLID_CARD_FORM: 'card-form',
	SOLID_APPLE_BUTTON: 'apple-pay-button-container',
	SOLID_PAYPAL_BUTTON: 'paypal-button',
	SOLID_GOOGLE_BUTTON: 'google-button',
	HEADER: 'header-with-decor',
	SPECIAL_BANNER: 'special-banner',
};
